<div class="mb-3">
  <div class="input-group">
    @for (axis of form.controls; track axis; let i = $index) {
      <span [hidden]='!axes[i]' class="input-group-text">
        <b>{{axes[i]}}</b>
      </span>
      @if ((!focusedField || focusedField == axes[i])) {
        <input [hidden]='!axes[i]' type='number'
          class="form-control" [formControl]="axis" (focus)="focusField(axes[i])" (focusout)="unfocusField()"
          (change)="onEdit()">
      }
    }
  </div>
</div>